/* eslint-disable react-refresh/only-export-components */

import type {ReactElement} from 'react';
import {useContext, useEffect, useState} from 'react';
import {EmailMakerAiRedesignPromptBox} from '@Components/email-maker-ai-redesign-prompt-box/email-maker-ai-redesign-prompt-box';
import {EmailMakerAiRewritePromptBox} from '@Components/email-maker-ai-rewrite-prompt-box/email-maker-ai-rewrite-prompt-box';
import {fetchAiRedesignRecentPrompt} from '@Libraries/email-campaign-ai-redesign-library';
import {emailMakerContext} from '@EmailMakerReact/email-maker-react.context';
import type {EmailMakerControl, EmailMakerControlProps} from '../../right-panel-registry.types';

let isRedesignFirstRender = true;

function AiRedesignControlInner(_props: EmailMakerControlProps): ReactElement | null {
  const {editor} = useContext(emailMakerContext);
  const [recentPrompt, setRecentPrompt] = useState<string | undefined>(undefined);
  const [hasFetched, setHasFetched] = useState(false);
  const showAnimation = isRedesignFirstRender;

  useEffect((): void => {
    if (hasFetched || !editor) {
      return;
    }
    setHasFetched(true);
    void (async (): Promise<void> => {
      const recent = await fetchAiRedesignRecentPrompt();
      setRecentPrompt(recent ?? undefined);
      if (isRedesignFirstRender) {
        isRedesignFirstRender = false;
      }
    })();
  }, [editor, hasFetched]);

  if (!editor) {
    return null;
  }

  return <EmailMakerAiRedesignPromptBox editor={editor} recentPrompt={recentPrompt} showInitialAnimation={showAnimation} />;
}

function AiRewriteControlInner({component}: EmailMakerControlProps): ReactElement | null {
  const {editor} = useContext(emailMakerContext);

  if (!editor) {
    return null;
  }

  return <EmailMakerAiRewritePromptBox editor={editor} selectedComponent={component} />;
}

/** Gate with `isVisible: isAiTextEnabled` in the sector definition. */
export function makeAiRedesignControl(): EmailMakerControl {
  return function AiRedesignControl(props: EmailMakerControlProps): ReactElement | null {
    return <AiRedesignControlInner {...props} />;
  };
}

/** Gate with `isVisible: isAiTextEnabled` in the sector definition. */
export function makeAiRewriteControl(): EmailMakerControl {
  return function AiRewriteControl(props: EmailMakerControlProps): ReactElement | null {
    return <AiRewriteControlInner {...props} />;
  };
}
